import Const from 'constants';
import SuffixMarker from 'services/simplex/suffix-marker';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_NHL_LEGACY_TEAM_STACKING_SUFFIX;

const NhlLegacyTeamStackingMarker = {
    suffix,
    ...SuffixMarker
};

export default NhlLegacyTeamStackingMarker;


